import { createAction } from 'redux-act';

import * as fillRate from '../../core/fillRate';

export const fetchFillRate = createAction(
  'get fill rate',
);
export const fetchFillRateSuccess = createAction(
  'get fill rate success',
  (allLogs) => allLogs
);
export const fetchFillRateFail = createAction(
  'get fill rate fail',
  (error) => error
);

export const reducer = {
  [fetchFillRate]: (state, payload) =>
    fillRate.fetchFillRate(state, payload),
  [fetchFillRateSuccess]: (state, payload) =>
    fillRate.fetchFillRateSuccess(state, payload),
};




/** WEBPACK FOOTER **
 ** ./js/redux/modules/fillRate.module.js
 **/